// removed by extract-text-webpack-plugin
module.exports = {"page":"containers-Intro-style__page__2-40K","code-example":"containers-Intro-style__code-example__2IcYN","codeExample":"containers-Intro-style__code-example__2IcYN","screenshot":"containers-Intro-style__screenshot__35Bh8","intro":"containers-Intro-style__intro__3iKru","intro-welcome":"containers-Intro-style__intro-welcome__2EQZ_","introWelcome":"containers-Intro-style__intro-welcome__2EQZ_","big-title":"containers-Intro-style__big-title__2_ptE","bigTitle":"containers-Intro-style__big-title__2_ptE","subtitle":"containers-Intro-style__subtitle__eje6G","topbar":"containers-Intro-style__topbar__2vk3N"};


//////////////////
// WEBPACK FOOTER
// ./containers/Intro/style.scss
// module id = 606
// module chunks = 0